



































































































































































import type { BuildingMenuTypes, ReportType, UploadState } from '@/constants/schema-constants'
import { BUILDING_MENU_TYPES, REPORT_TYPES, UPLOAD_STATE } from '@/constants/schema-constants'
import { CurrentAdminManager } from '@/mixins/current-admin-manager'
import { staticRoutes } from '@/routes'
import { Component, Mixins, Watch } from 'vue-property-decorator'

import { Choice } from '@/components/molecules/SmBtnToggle.vue'
import { FilterLabel } from '@/components/molecules/SmExpansionFilterMenu.vue'
import { LoadingHandler } from '@/components/molecules/SmInfiniteLoading.vue'
import { Header } from '@/components/molecules/SmTableDataExternalPaging.vue'

import { Building, BuildingsGetRequest } from '@/dtos/buildings/get'
import { Material } from '@/dtos/commons'
import { ReportFileTaskStatusPutRequest } from '@/dtos/report-files/put'
import { ReportFile, ReportFilesSearchPostRequest } from '@/dtos/report-files/search/post'
import { getReportTypeLabel, getUploadStateLabel } from '@/libs/state-handler'
import { generateUuid } from '@/libs/uuid-generator'

import { buildingsModule } from '@/stores/buildings-store'
import { errorsModule } from '@/stores/errors'
import { paramStorageModule } from '@/stores/param-storage-store'
import { reportFilesModule } from '@/stores/report-files-store'

const BUILDING_MENU_ITEMS_FOR_REPORT_FILES: {[id: string]: { text: string, label: string }} = {
  all: {
    text: 'すべてのマンション',
    label: '変更する'
  },
  each: {
    text: '個別に選択する',
    label: '変更する'
  },
}

const SELECTED_REPORT_TYPES = {
  MANAGEMENT: 'management',
  ADMINISTRATIVE: 'administrative',
  PAYMENT_APPROVAL: 'paymentApproval',
}
type SelectedReportType = typeof SELECTED_REPORT_TYPES[keyof typeof SELECTED_REPORT_TYPES]

const SELECTED_UPLOAD_STATES = {
  NOT_UPLOADED: 'notUploaded',
  UPLOADED: 'uploaded',
  NOT_REQUIRED: 'notRequired'
}
type SelectedUploadState = typeof SELECTED_UPLOAD_STATES[keyof typeof SELECTED_UPLOAD_STATES]

const SELECTED_REPORT_TYPE_TO_REPORT_TYPE: Record<SelectedReportType, ReportType> = {
  [SELECTED_REPORT_TYPES.MANAGEMENT]: REPORT_TYPES.MANAGEMENT,
  [SELECTED_REPORT_TYPES.ADMINISTRATIVE]: REPORT_TYPES.ADMINISTRATIVE,
  [SELECTED_REPORT_TYPES.PAYMENT_APPROVAL]: REPORT_TYPES.PAYMENT_APPROVAL
}

const SELECTED_UPLOAD_STATE_TO_UPLOAD_STATE: Record<SelectedUploadState, UploadState> = {
  [SELECTED_UPLOAD_STATES.NOT_UPLOADED]: UPLOAD_STATE.NOT_UPLOADED,
  [SELECTED_UPLOAD_STATES.UPLOADED]: UPLOAD_STATE.UPLOADED,
  [SELECTED_UPLOAD_STATES.NOT_REQUIRED]: UPLOAD_STATE.NOT_REQUIRED
}

const REPORT_TYPE_TO_SELECTED_REPORT_TYPE: Record<ReportType, SelectedReportType> = {
  [REPORT_TYPES.MANAGEMENT]: SELECTED_REPORT_TYPES.MANAGEMENT,
  [REPORT_TYPES.ADMINISTRATIVE]: SELECTED_REPORT_TYPES.ADMINISTRATIVE,
  [REPORT_TYPES.PAYMENT_APPROVAL]: SELECTED_REPORT_TYPES.PAYMENT_APPROVAL,
}

const UPLOAD_STATE_TO_SELECTED_UPLOAD_STATE: Record<UploadState, SelectedUploadState> = {
  [UPLOAD_STATE.NOT_UPLOADED]: SELECTED_UPLOAD_STATES.NOT_UPLOADED,
  [UPLOAD_STATE.UPLOADED]: SELECTED_UPLOAD_STATES.UPLOADED,
  [UPLOAD_STATE.NOT_REQUIRED]: SELECTED_UPLOAD_STATES.NOT_REQUIRED,
}

const TAKE = 50
const STORAGE_KEY = staticRoutes.reportFilesList.name

// storeに検索条件を保存するためのクラス
class ReportFilesSearchCondition extends ReportFilesSearchPostRequest {
  buildingMenuType!: BuildingMenuTypes
}

// テーブルに表示させるのに必要な内容
class ReportFileItem {
  reportUploadId!: string;
  buildingName!: string;
  reportTypeName!: string;
  uploadOrder?: string | null | undefined = null;
  period!: number;
  targetYearMonth!: string;
  uploadStateName!: string;
  material?: Material | null | undefined = null;
  version! :number;
}

@Component({
  components: {
    SmBtn: () => import('@/components/atoms/SmBtn.vue'),
    SmBtnText: () => import('@/components/atoms/SmBtnText.vue'),
    SmSelect: () => import('@/components/atoms/SmSelect.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmBtnToggle: () => import('@/components/molecules/SmBtnToggle.vue'),
    SmExpansionFilterMenu: () => import('@/components/molecules/SmExpansionFilterMenu.vue'),
    SmMaterialDisplay: () => import('@/components/molecules/SmMaterialDisplay.vue'),
    SmMenu: () => import('@/components/molecules/SmMenu.vue'),
    SmTableDataExternalPaging: () => import('@/components/molecules/SmTableDataExternalPaging.vue'),
    SmTextField: () => import('@/components/molecules/SmTextField.vue'),

    BuildingSelectModal: () => import('@/components/organisms/modal/BuildingSelectModal.vue'),

    SmTemplate: () => import('@/components/templates/SmTemplate.vue'),
  }
})
export default class ReportFilesListUploadPage extends Mixins(CurrentAdminManager) {
 TAKE = Object.freeze(TAKE)
 pageNum = 1

  // リクエストパラメータ
  searchCondition: ReportFilesSearchCondition = new ReportFilesSearchCondition(0, TAKE)

  // 絞り込み条件
  selectedReportTypes: string[] = []
  selectedUploadStates: string[] = []
  selectedBuildings: Building[] = []
  period = 0
  targetYearMonth = ''

  selectedBuildingMenuType: BuildingMenuTypes = BUILDING_MENU_TYPES.ALL // マンションの絞り込みメニューの種類

  selectedBuildingDisplay = 'すべてのマンション'

  private get buildingNames(): string {
    return this.selectedBuildings.map(b => b.buildingName).join(' | ')
  }

  UPLOAD_STATE = Object.freeze(UPLOAD_STATE)

  BUILDING_MENU_ITEMS_FOR_REPORT_FILES = Object.freeze(BUILDING_MENU_ITEMS_FOR_REPORT_FILES)
  selectedBuildingsByEach: Building[] = [] // 個別選択ダイアログで以前選択した物件を保持しておく変数

  // --------------- 報告書表示関連 ---------------

  // 絞り込みメニューのラベル名（各slotのname属性ごとにラベルを用意する）
  filterLabels = {
    condition1: new FilterLabel('マンション', 'center', '160px'),
    condition2: new FilterLabel('報告書タイプ', 'center', '160px'),
    condition3: new FilterLabel('アップロード状況', 'center', '160px'),
    condition4: new FilterLabel('期', 'center', '160px'),
    condition5: new FilterLabel('年月', 'center', '160px'),
  }

  tableHeaders: Header[] = [
    new Header({ text: 'マンション名', value: 'buildingName', sortable: false, width: '180px' }),
    new Header({ text: '報告書タイプ', value: 'reportTypeName', sortable: false, width: '160px' }),
    new Header({ text: '期', value: 'period', sortable: false, width: '46px' }),
    new Header({ text: '年月', value: 'targetYearMonth', sortable: false, width: '110px' }),
    new Header({ text: '投稿回数', value: 'uploadOrder', sortable: false, width: '130px' }),
    new Header({ text: 'アップロード状況', value: 'uploadStateName', sortable: false, width: '230px' }),
    new Header({ text: 'ファイル', value: 'material', sortable: false, width: '320px' }),
  ]

  // トグルボタン
  reportTypeChoice: Choice[] = [
    new Choice(SELECTED_REPORT_TYPES.MANAGEMENT, '管理状況報告書'),
    new Choice(SELECTED_REPORT_TYPES.ADMINISTRATIVE, '月次管理事務報告書'),
    new Choice(SELECTED_REPORT_TYPES.PAYMENT_APPROVAL, '振込承認依頼書'),
  ]

  uploadStateChoice: Choice[] = [
    new Choice(SELECTED_UPLOAD_STATES.NOT_UPLOADED, '未'),
    new Choice(SELECTED_UPLOAD_STATES.UPLOADED, '済'),
    new Choice(SELECTED_UPLOAD_STATES.NOT_REQUIRED, 'アップ不要'),
  ]

  private get reportFiles(): ReportFileItem[] {
    const _reportFiles = reportFilesModule.reportFilesSearchPostResponse.reportFiles
    if (_reportFiles.length === 0) return []
    return _reportFiles.map(reportFile => this.toReportFilesItem(reportFile))
  }

  private get periodList(): { value: number, label: string }[] {
    const periodList: number[] | undefined = reportFilesModule.reportFilesSearchPostResponse.periodList
    if (!periodList) return []
    const resultList = [{ value: 0, label: '全期' }]
    periodList.forEach(period => {
      resultList.push({ value: period, label: `${period}期` })
    })
    return resultList
  }

  private get targetYearMonthList(): string[] {
    const targetYearMonthList: string[] | undefined = reportFilesModule.reportFilesSearchPostResponse.targetYearMonthList
    if (!targetYearMonthList) return []
    return ['すべて', ...targetYearMonthList]
  }

  private get reportFilesCount(): number { return reportFilesModule.reportFilesSearchPostResponse.reportFilesCount ?? 0 }

  toReportFilesItem(reportFile: ReportFile): ReportFileItem {
    const item = new ReportFileItem()

    item.reportUploadId = reportFile.reportUploadId
    item.buildingName = reportFile.buildingName
    item.reportTypeName = getReportTypeLabel(reportFile.reportType)
    item.uploadOrder = reportFile.uploadOrder != null ? `${reportFile.uploadOrder}回目` : null
    item.period = reportFile.period
    item.targetYearMonth = reportFile.targetYearMonth
    item.uploadStateName = getUploadStateLabel(reportFile.uploadState)
    item.material = reportFile.material
    item.version = reportFile.version
    return item
  }

  async onClickPageBtn(pageNum: number): Promise<void> {
    this.pageNum = pageNum
    await this.search()
  }

  // 絞り込みを行っているかを判定（報告書が0件（コンテンツが0件）の場合trueを返す）
  private get isInitSearch(): boolean {
    if ((this.searchCondition?.reportTypes?.length ?? 0) > 0 ||
      (this.searchCondition?.uploadStates?.length ?? 0) > 0 ||
      (this.searchCondition?.buildings?.length ?? 0) > 0 ||
      this.searchCondition?.period ||
      this.searchCondition?.targetYearMonth
    ) {
      return false
    }
    return true
  }

  async created():Promise<void> {
    await buildingsModule.fetchBuildings(new BuildingsGetRequest(0, 999))
    this.searchCondition.uploadStates = [UPLOAD_STATE.NOT_UPLOADED, UPLOAD_STATE.UPLOADED]
    // 初期検索パラメーターの設定（以前の検索条件が残っている場合、それを復元して反映）
    const stored = paramStorageModule.savedParam(STORAGE_KEY, ReportFilesSearchCondition)
    if (stored) {
      this.searchCondition = stored
    }
    if (this.searchCondition.reportTypes) this.selectedReportTypes = this.changeToSelectedReportTypes(this.searchCondition.reportTypes)
    this.selectedUploadStates = this.changeToSelectedUploadStates(this.searchCondition.uploadStates)
    if (this.searchCondition.buildingMenuType === BUILDING_MENU_TYPES.EACH) {
      this.selectedBuildingMenuType = this.searchCondition.buildingMenuType
      this.selectedBuildings = this.getTargetBuildings(this.searchCondition.buildings)
      this.selectedBuildingsByEach = this.selectedBuildings
      this.setSelectedBuildingDisplay()
    }
    if (this.searchCondition.period) { this.period = this.searchCondition.period }
    if (this.searchCondition.targetYearMonth) this.targetYearMonth = this.searchCondition.targetYearMonth
    if (this.targetYearMonth) {
      const match = this.targetYearMonth.match(/^(\d{4})-(\d{2})$/)
      if (match) {
        const year = match[1]
        const month = match[2]
        this.targetYearMonth = `${year}年${month}月`
      }
    } else {
      this.targetYearMonth = 'すべて'
    }

    this.search()
  }

  changeToSelectedReportTypes(reportTypes: ReportType[]): string[] {
    return reportTypes.flatMap(reportType => REPORT_TYPE_TO_SELECTED_REPORT_TYPE[reportType])
  }

  changeToSelectedUploadStates(uploadStates?: UploadState[]): string[] {
    if (!uploadStates) return []

    return uploadStates.flatMap(uploadState => UPLOAD_STATE_TO_SELECTED_UPLOAD_STATE[uploadState])
  }

  getTargetBuildings(buildingIds?: string[]): Building[] {
    return buildingsModule.buildingsGet.buildings.filter(b => buildingIds?.includes(b.buildingId))
  }

  isFilterMenuOpen = true

  // --------------- データの読み込み ---------------
  isWaitingSwitch = false // switch・toggleの連打防止用
  handler: LoadingHandler | null = null

  async search(): Promise<void> {
    this.isWaitingSwitch = true
    await reportFilesModule.fetchReportFiles(this.toSearchPostRequest())
    paramStorageModule.save({ key: STORAGE_KEY, params: { ...this.searchCondition } })
    this.isWaitingSwitch = false
  }

  toSearchPostRequest(): ReportFilesSearchPostRequest {
    const req = new ReportFilesSearchPostRequest(
      TAKE * (this.pageNum - 1), TAKE)
    req.reportTypes = this.searchCondition?.reportTypes?.length ? this.searchCondition.reportTypes : undefined
    req.uploadStates = this.searchCondition?.uploadStates?.length ? this.searchCondition.uploadStates : undefined
    req.buildings = this.searchCondition?.buildings?.length ? this.searchCondition.buildings : undefined
    req.period = this.searchCondition?.period ?? undefined
    req.targetYearMonth = this.searchCondition?.targetYearMonth ?? undefined
    return req
  }

  truncateString(inputString: string, truncateLength :number): string {
    if (inputString.length <= truncateLength) {
      return inputString
    } else {
      return inputString.slice(0, truncateLength - 2) + '･･･'
    }
  }

  // --------------- ボタンなどを押下した際の処理 ---------------

  goToFileNamingRulesPage(): void {
    this.$router.push({ name: staticRoutes.fileNamingRules.name })
  }

  goToReportFileUploadPage(): void {
    this.$router.push({ name: staticRoutes.reportFileUpload.name })
  }

  // 絞り込み処理
  onChangeReportTypes(): void {
    const reportTypes = this.selectedReportTypes.flatMap(selectedType => SELECTED_REPORT_TYPE_TO_REPORT_TYPE[selectedType])

    this.searchCondition.reportTypes = reportTypes
    this.pageNum = 1
    this.search()
  }

  onChangeUploadStates(): void {
    const uploadStates = this.selectedUploadStates.flatMap(selectedState => SELECTED_UPLOAD_STATE_TO_UPLOAD_STATE[selectedState])

    this.searchCondition.uploadStates = uploadStates
    this.pageNum = 1
    this.search()
  }

  onChangePeriod(): void {
    if (this.period === 0) {
      this.searchCondition.period = undefined
    } else {
      this.searchCondition.period = this.period
    }
    this.pageNum = 1
    this.search()
  }

  onChangeTargetYearMonth(): void {
    const yearMonthMatch = this.targetYearMonth.match(/(\d{4})年(\d{2})月/)
    if (yearMonthMatch) {
      const year = yearMonthMatch[1]
      const month = yearMonthMatch[2]

      this.searchCondition.targetYearMonth = `${year}-${month}`
    }
    if (this.targetYearMonth === 'すべて') {
      this.searchCondition.targetYearMonth = undefined
    }
    this.pageNum = 1
    this.search()
  }

  async onChangeToNotRequiredOrNotUploaded(reportFileItem: ReportFileItem, uploadState: UploadState): Promise<void> {
    const res = await reportFilesModule.updateReportFileTaskStatus(this.toReportFileTaskStatusPutRequest(reportFileItem, uploadState))
    if (res) reportFileItem.version = res.version
    this.search()
  }

  toReportFileTaskStatusPutRequest(reportFileItem: ReportFileItem, uploadState: UploadState): ReportFileTaskStatusPutRequest {
    const req = new ReportFileTaskStatusPutRequest(
      reportFileItem.reportUploadId, uploadState, reportFileItem.version)

    return req
  }

  selectBuildingMenu(): void {
    switch (this.selectedBuildingMenuType) {
      case BUILDING_MENU_TYPES.ALL:
        this.onChangeBuilding()
        break
      case BUILDING_MENU_TYPES.EACH:
        this.openBuildingSelectModal()
        break
    }
  }

  onChangeBuilding(buildingIds?: string[]): void {
    this.selectedBuildings = this.getTargetBuildings(buildingIds)

    // 個別マンション選択ダイアログで選択されたマンションを保持する（それ以外の場合はクリア）
    this.selectedBuildingsByEach = this.selectedBuildingMenuType === BUILDING_MENU_TYPES.EACH ? this.selectedBuildings : []

    // 物件IDを検索条件に追加する
    this.searchCondition.buildings = buildingIds ?? []

    this.searchCondition.buildingMenuType = this.selectedBuildingMenuType

    this.setSelectedBuildingDisplay()
    this.pageNum = 1
    this.search()
  }

  // マンションの横に表示するラベルをセットする
  setSelectedBuildingDisplay(): void {
    switch (this.selectedBuildingMenuType) {
      case BUILDING_MENU_TYPES.ALL:
        this.selectedBuildingDisplay = 'すべてのマンション'
        break
      case BUILDING_MENU_TYPES.EACH:
        this.selectedBuildingDisplay = this.buildingNames
        break
    }
  }

  // --------------- データ読み込みでエラーが発生した際の処理 ---------------
  private get hasErrors(): boolean { return errorsModule.hasErrors }

  @Watch('hasErrors', { immediate: false, deep: false })
  private onLoadError(hasErrors: boolean): void {
    if (!hasErrors) return

    this.handler?.complete()
    this.isWaitingSwitch = false
  }

  // --------------- モーダル表示等の処理 ---------------

  // 物件個別選択モーダル
  inputText = ''
  buildingKeyword = ''

  isBuildingSelectModalVisible = false
  buildingSelectModalKey = generateUuid()
  openBuildingSelectModal(): void {
    this.buildingSelectModalKey = generateUuid()
    this.isBuildingSelectModalVisible = true
  }
}
